import './styles.scss';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'utils/common';

const propTypes = {
  location: PropTypes.object.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
      icon: PropTypes.string
    })
  ).isRequired
};
const defaultProps = {};

class StepIndicator extends Component {
  render() {
    const { location, steps } = this.props;
    const maxSteps = steps ? steps.length - 1 : 0;

    const isActive = url => `/${url}` === location.pathname;

    return (
      <div className="step-indicator-wrapper col-sm-12">
        <div>
          {steps.map((step, i) => (
            <Fragment key={i}>
              <span className={`step-indicator-wrapper__step ${isActive(step.url) ? 'active' : ''}`}>
                <span className="step-label">{step.text}</span>
                <span className={`step-icon icon--${step.icon}`}></span>
                {i < maxSteps && <span className="step-indicator-flow" />}
              </span>
              {i + 1 !== steps.length && <span className="step-dash"></span>}
            </Fragment>
          ))}
        </div>
      </div>
    );
  }
}

StepIndicator.propTypes = propTypes;
StepIndicator.defaultProps = defaultProps;
const StepIndicatorWithRouter = withRouter(StepIndicator);

export default StepIndicatorWithRouter;
